type GridColSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13
type GridRowSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7

export type StrapiLayoutItem = {
  i: string
  x: number
  y: number
  h: number
  w: number
}

export type GridLayoutItem = {
  index: number
  key: string
  gridColumnStart: GridColSpan
  gridColumnEnd: GridColSpan
  gridRowStart: GridRowSpan
  gridRowEnd: GridRowSpan
}

const clampToGridColSpan = (value: number): GridColSpan => {
  const clamped = Math.max(1, Math.min(13, value))
  return clamped as GridColSpan
}
const clampToGridRowSpan = (value: number): GridRowSpan => {
  const clamped = Math.max(1, Math.min(7, value))
  return clamped as GridRowSpan
}

export const formatGridLayout = (items: StrapiLayoutItem[]): GridLayoutItem[] =>
  items?.map((item, index) => ({
    index,
    key: item.i,
    gridColumnStart: clampToGridColSpan(item.x + 1),
    gridColumnEnd: clampToGridColSpan(item.x + item.w + 1),
    gridRowStart: clampToGridRowSpan(item.y + 1),
    gridRowEnd: clampToGridRowSpan(item.y + item.h + 1),
  }))

export const getGridOrder = (items: GridLayoutItem[]): number[] => {
  const sortedItems = [...items]
  sortedItems.sort((a, b) => {
    if (a.gridRowStart === b.gridRowStart) {
      return a.gridColumnStart - b.gridColumnStart
    }
    return a.gridRowStart - b.gridRowStart
  })
  const sortedIndices = sortedItems.map(item => item?.index)
  const orderedPositions = Array(sortedItems?.length)
  sortedIndices.forEach((index, i) => {
    orderedPositions[index] = i
  })
  return orderedPositions
}

export const getGridFormatsAndOrders = ({
  desktopGridLayout,
  tabletGridLayout,
  mobileGridLayout,
}: {
  desktopGridLayout: StrapiLayoutItem[]
  tabletGridLayout: StrapiLayoutItem[]
  mobileGridLayout: StrapiLayoutItem[]
}) => {
  const desktopLayout = formatGridLayout(desktopGridLayout)
  const tabletLayout = formatGridLayout(tabletGridLayout)
  const mobileLayout = formatGridLayout(mobileGridLayout)
  const desktopPosition = getGridOrder(desktopLayout)
  const tabletPosition = getGridOrder(tabletLayout)
  const mobilePosition = getGridOrder(mobileLayout)

  return { desktopLayout, tabletLayout, mobileLayout, desktopPosition, tabletPosition, mobilePosition }
}
